/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssigneesOut,
  HTTPValidationError,
  ListRecurringWorkOrdersParams,
  ListWorkOrdersParams,
  PaginatedRecurringWorkOrderOut,
  PaginatedWorkOrderOut,
  RecurringWorkOrderIn,
  RecurringWorkOrderOut,
  WorkOrderIn,
  WorkOrderOut,
  WorkOrderSummaryOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listRecurringWorkOrdersResponse200 = {
  data: PaginatedRecurringWorkOrderOut
  status: 200
}

export type listRecurringWorkOrdersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listRecurringWorkOrdersResponseSuccess = (listRecurringWorkOrdersResponse200) & {
  headers: Headers;
};
export type listRecurringWorkOrdersResponseError = (listRecurringWorkOrdersResponse422) & {
  headers: Headers;
};

export type listRecurringWorkOrdersResponse = (listRecurringWorkOrdersResponseSuccess | listRecurringWorkOrdersResponseError)

export const getListRecurringWorkOrdersUrl = (params?: ListRecurringWorkOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/recurring-work-orders?${stringifiedParams}` : `/api/recurring-work-orders`
}

/**
 * @summary List Recurring Work Orders
 */
export const listRecurringWorkOrders = async (params?: ListRecurringWorkOrdersParams, options?: Parameters<typeof apiFetch>[1]): Promise<listRecurringWorkOrdersResponse> => {

  return apiFetch<listRecurringWorkOrdersResponse>(getListRecurringWorkOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecurringWorkOrdersQueryKey = (params?: ListRecurringWorkOrdersParams,) => {
    return [
    `/api/recurring-work-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRecurringWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError = HTTPValidationError>(params?: ListRecurringWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecurringWorkOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecurringWorkOrders>>> = ({ signal }) => listRecurringWorkOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecurringWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listRecurringWorkOrders>>>
export type ListRecurringWorkOrdersQueryError = HTTPValidationError


export function useListRecurringWorkOrders<TData = Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError = HTTPValidationError>(
 params: undefined |  ListRecurringWorkOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecurringWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof listRecurringWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecurringWorkOrders<TData = Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError = HTTPValidationError>(
 params?: ListRecurringWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecurringWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof listRecurringWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecurringWorkOrders<TData = Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError = HTTPValidationError>(
 params?: ListRecurringWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Recurring Work Orders
 */

export function useListRecurringWorkOrders<TData = Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError = HTTPValidationError>(
 params?: ListRecurringWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecurringWorkOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createRecurringWorkOrderResponse201 = {
  data: RecurringWorkOrderOut
  status: 201
}

export type createRecurringWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createRecurringWorkOrderResponseSuccess = (createRecurringWorkOrderResponse201) & {
  headers: Headers;
};
export type createRecurringWorkOrderResponseError = (createRecurringWorkOrderResponse422) & {
  headers: Headers;
};

export type createRecurringWorkOrderResponse = (createRecurringWorkOrderResponseSuccess | createRecurringWorkOrderResponseError)

export const getCreateRecurringWorkOrderUrl = () => {




  return `/api/recurring-work-orders`
}

/**
 * @summary Create Recurring Work Order
 */
export const createRecurringWorkOrder = async (recurringWorkOrderIn: RecurringWorkOrderIn, options?: Parameters<typeof apiFetch>[1]): Promise<createRecurringWorkOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createRecurringWorkOrderResponse>(getCreateRecurringWorkOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recurringWorkOrderIn)
  }
);}





export const getCreateRecurringWorkOrderMutationKey = () => ['createRecurringWorkOrder'] as const;

export const getCreateRecurringWorkOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRecurringWorkOrder>>, TError,CreateRecurringWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRecurringWorkOrder>>, TError,CreateRecurringWorkOrderMutationVariables, TContext> => {

const mutationKey = getCreateRecurringWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRecurringWorkOrder>>, CreateRecurringWorkOrderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRecurringWorkOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRecurringWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createRecurringWorkOrder>>>
    export type CreateRecurringWorkOrderMutationBody = RecurringWorkOrderIn
    export type CreateRecurringWorkOrderMutationError = HTTPValidationError
    export type CreateRecurringWorkOrderMutationVariables = {data: RecurringWorkOrderIn}

    /**
 * @summary Create Recurring Work Order
 */
export const useCreateRecurringWorkOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRecurringWorkOrder>>, TError,CreateRecurringWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRecurringWorkOrder>>,
        TError,
        CreateRecurringWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRecurringWorkOrderMutationOptions(options), queryClient);
    }
    export type updateRecurringWorkOrderResponse200 = {
  data: RecurringWorkOrderOut
  status: 200
}

export type updateRecurringWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateRecurringWorkOrderResponseSuccess = (updateRecurringWorkOrderResponse200) & {
  headers: Headers;
};
export type updateRecurringWorkOrderResponseError = (updateRecurringWorkOrderResponse422) & {
  headers: Headers;
};

export type updateRecurringWorkOrderResponse = (updateRecurringWorkOrderResponseSuccess | updateRecurringWorkOrderResponseError)

export const getUpdateRecurringWorkOrderUrl = (recurringId: number,) => {




  return `/api/recurring-work-orders/${recurringId}`
}

/**
 * @summary Update Recurring Work Order
 */
export const updateRecurringWorkOrder = async (recurringId: number,
    recurringWorkOrderIn: RecurringWorkOrderIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateRecurringWorkOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateRecurringWorkOrderResponse>(getUpdateRecurringWorkOrderUrl(recurringId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recurringWorkOrderIn)
  }
);}





export const getUpdateRecurringWorkOrderMutationKey = () => ['updateRecurringWorkOrder'] as const;

export const getUpdateRecurringWorkOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecurringWorkOrder>>, TError,UpdateRecurringWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRecurringWorkOrder>>, TError,UpdateRecurringWorkOrderMutationVariables, TContext> => {

const mutationKey = getUpdateRecurringWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRecurringWorkOrder>>, UpdateRecurringWorkOrderMutationVariables> = (props) => {
          const {recurringId,data} = props ?? {};

          return  updateRecurringWorkOrder(recurringId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRecurringWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecurringWorkOrder>>>
    export type UpdateRecurringWorkOrderMutationBody = RecurringWorkOrderIn
    export type UpdateRecurringWorkOrderMutationError = HTTPValidationError
    export type UpdateRecurringWorkOrderMutationVariables = {recurringId: number;data: RecurringWorkOrderIn}

    /**
 * @summary Update Recurring Work Order
 */
export const useUpdateRecurringWorkOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecurringWorkOrder>>, TError,UpdateRecurringWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRecurringWorkOrder>>,
        TError,
        UpdateRecurringWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRecurringWorkOrderMutationOptions(options), queryClient);
    }
    export type deleteRecurringWorkOrderResponse204 = {
  data: void
  status: 204
}

export type deleteRecurringWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteRecurringWorkOrderResponseSuccess = (deleteRecurringWorkOrderResponse204) & {
  headers: Headers;
};
export type deleteRecurringWorkOrderResponseError = (deleteRecurringWorkOrderResponse422) & {
  headers: Headers;
};

export type deleteRecurringWorkOrderResponse = (deleteRecurringWorkOrderResponseSuccess | deleteRecurringWorkOrderResponseError)

export const getDeleteRecurringWorkOrderUrl = (recurringId: number,) => {




  return `/api/recurring-work-orders/${recurringId}`
}

/**
 * @summary Delete Recurring Work Order
 */
export const deleteRecurringWorkOrder = async (recurringId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteRecurringWorkOrderResponse> => {

  return apiFetch<deleteRecurringWorkOrderResponse>(getDeleteRecurringWorkOrderUrl(recurringId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRecurringWorkOrderMutationKey = () => ['deleteRecurringWorkOrder'] as const;

export const getDeleteRecurringWorkOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecurringWorkOrder>>, TError,DeleteRecurringWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRecurringWorkOrder>>, TError,DeleteRecurringWorkOrderMutationVariables, TContext> => {

const mutationKey = getDeleteRecurringWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRecurringWorkOrder>>, DeleteRecurringWorkOrderMutationVariables> = (props) => {
          const {recurringId} = props ?? {};

          return  deleteRecurringWorkOrder(recurringId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRecurringWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRecurringWorkOrder>>>

    export type DeleteRecurringWorkOrderMutationError = HTTPValidationError
    export type DeleteRecurringWorkOrderMutationVariables = {recurringId: number}

    /**
 * @summary Delete Recurring Work Order
 */
export const useDeleteRecurringWorkOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecurringWorkOrder>>, TError,DeleteRecurringWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRecurringWorkOrder>>,
        TError,
        DeleteRecurringWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteRecurringWorkOrderMutationOptions(options), queryClient);
    }
    export type listWorkOrdersResponse200 = {
  data: PaginatedWorkOrderOut
  status: 200
}

export type listWorkOrdersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listWorkOrdersResponseSuccess = (listWorkOrdersResponse200) & {
  headers: Headers;
};
export type listWorkOrdersResponseError = (listWorkOrdersResponse422) & {
  headers: Headers;
};

export type listWorkOrdersResponse = (listWorkOrdersResponseSuccess | listWorkOrdersResponseError)

export const getListWorkOrdersUrl = (params?: ListWorkOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/work-orders?${stringifiedParams}` : `/api/work-orders`
}

/**
 * @summary List Work Orders
 */
export const listWorkOrders = async (params?: ListWorkOrdersParams, options?: Parameters<typeof apiFetch>[1]): Promise<listWorkOrdersResponse> => {

  return apiFetch<listWorkOrdersResponse>(getListWorkOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkOrdersQueryKey = (params?: ListWorkOrdersParams,) => {
    return [
    `/api/work-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listWorkOrders>>, TError = HTTPValidationError>(params?: ListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkOrders>>> = ({ signal }) => listWorkOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkOrders>>>
export type ListWorkOrdersQueryError = HTTPValidationError


export function useListWorkOrders<TData = Awaited<ReturnType<typeof listWorkOrders>>, TError = HTTPValidationError>(
 params: undefined |  ListWorkOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof listWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkOrders<TData = Awaited<ReturnType<typeof listWorkOrders>>, TError = HTTPValidationError>(
 params?: ListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof listWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkOrders<TData = Awaited<ReturnType<typeof listWorkOrders>>, TError = HTTPValidationError>(
 params?: ListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Work Orders
 */

export function useListWorkOrders<TData = Awaited<ReturnType<typeof listWorkOrders>>, TError = HTTPValidationError>(
 params?: ListWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorkOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createWorkOrderResponse201 = {
  data: WorkOrderOut
  status: 201
}

export type createWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createWorkOrderResponseSuccess = (createWorkOrderResponse201) & {
  headers: Headers;
};
export type createWorkOrderResponseError = (createWorkOrderResponse422) & {
  headers: Headers;
};

export type createWorkOrderResponse = (createWorkOrderResponseSuccess | createWorkOrderResponseError)

export const getCreateWorkOrderUrl = () => {




  return `/api/work-orders`
}

/**
 * @summary Create Work Order
 */
export const createWorkOrder = async (workOrderIn: WorkOrderIn, options?: Parameters<typeof apiFetch>[1]): Promise<createWorkOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createWorkOrderResponse>(getCreateWorkOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workOrderIn)
  }
);}





export const getCreateWorkOrderMutationKey = () => ['createWorkOrder'] as const;

export const getCreateWorkOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkOrder>>, TError,CreateWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkOrder>>, TError,CreateWorkOrderMutationVariables, TContext> => {

const mutationKey = getCreateWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkOrder>>, CreateWorkOrderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWorkOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkOrder>>>
    export type CreateWorkOrderMutationBody = WorkOrderIn
    export type CreateWorkOrderMutationError = HTTPValidationError
    export type CreateWorkOrderMutationVariables = {data: WorkOrderIn}

    /**
 * @summary Create Work Order
 */
export const useCreateWorkOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkOrder>>, TError,CreateWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkOrder>>,
        TError,
        CreateWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorkOrderMutationOptions(options), queryClient);
    }
    export type getWorkOrderSummaryResponse200 = {
  data: WorkOrderSummaryOut
  status: 200
}

export type getWorkOrderSummaryResponseSuccess = (getWorkOrderSummaryResponse200) & {
  headers: Headers;
};
;

export type getWorkOrderSummaryResponse = (getWorkOrderSummaryResponseSuccess)

export const getGetWorkOrderSummaryUrl = () => {




  return `/api/work-orders/summary`
}

/**
 * @summary Get Work Order Summary
 */
export const getWorkOrderSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getWorkOrderSummaryResponse> => {

  return apiFetch<getWorkOrderSummaryResponse>(getGetWorkOrderSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkOrderSummaryQueryKey = () => {
    return [
    `/api/work-orders/summary`
    ] as const;
    }


export const getGetWorkOrderSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getWorkOrderSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrderSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkOrderSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkOrderSummary>>> = ({ signal }) => getWorkOrderSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkOrderSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkOrderSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkOrderSummary>>>
export type GetWorkOrderSummaryQueryError = unknown


export function useGetWorkOrderSummary<TData = Awaited<ReturnType<typeof getWorkOrderSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrderSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkOrderSummary>>,
          TError,
          Awaited<ReturnType<typeof getWorkOrderSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkOrderSummary<TData = Awaited<ReturnType<typeof getWorkOrderSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrderSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkOrderSummary>>,
          TError,
          Awaited<ReturnType<typeof getWorkOrderSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkOrderSummary<TData = Awaited<ReturnType<typeof getWorkOrderSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrderSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Work Order Summary
 */

export function useGetWorkOrderSummary<TData = Awaited<ReturnType<typeof getWorkOrderSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrderSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkOrderSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listWorkOrderAssigneesResponse200 = {
  data: AssigneesOut
  status: 200
}

export type listWorkOrderAssigneesResponseSuccess = (listWorkOrderAssigneesResponse200) & {
  headers: Headers;
};
;

export type listWorkOrderAssigneesResponse = (listWorkOrderAssigneesResponseSuccess)

export const getListWorkOrderAssigneesUrl = () => {




  return `/api/work-orders/assignees`
}

/**
 * @summary List Work Order Assignees
 */
export const listWorkOrderAssignees = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listWorkOrderAssigneesResponse> => {

  return apiFetch<listWorkOrderAssigneesResponse>(getListWorkOrderAssigneesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkOrderAssigneesQueryKey = () => {
    return [
    `/api/work-orders/assignees`
    ] as const;
    }


export const getListWorkOrderAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkOrderAssigneesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkOrderAssignees>>> = ({ signal }) => listWorkOrderAssignees({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWorkOrderAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkOrderAssignees>>>
export type ListWorkOrderAssigneesQueryError = unknown


export function useListWorkOrderAssignees<TData = Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkOrderAssignees>>,
          TError,
          Awaited<ReturnType<typeof listWorkOrderAssignees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkOrderAssignees<TData = Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkOrderAssignees>>,
          TError,
          Awaited<ReturnType<typeof listWorkOrderAssignees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkOrderAssignees<TData = Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Work Order Assignees
 */

export function useListWorkOrderAssignees<TData = Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkOrderAssignees>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorkOrderAssigneesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getWorkOrderResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type getWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getWorkOrderResponseSuccess = (getWorkOrderResponse200) & {
  headers: Headers;
};
export type getWorkOrderResponseError = (getWorkOrderResponse422) & {
  headers: Headers;
};

export type getWorkOrderResponse = (getWorkOrderResponseSuccess | getWorkOrderResponseError)

export const getGetWorkOrderUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}`
}

/**
 * @summary Get Work Order
 */
export const getWorkOrder = async (workOrderId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getWorkOrderResponse> => {

  return apiFetch<getWorkOrderResponse>(getGetWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkOrderQueryKey = (workOrderId: number,) => {
    return [
    `/api/work-orders/${workOrderId}`
    ] as const;
    }


export const getGetWorkOrderQueryOptions = <TData = Awaited<ReturnType<typeof getWorkOrder>>, TError = HTTPValidationError>(workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkOrderQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkOrder>>> = ({ signal }) => getWorkOrder(workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workOrderId !== null && workOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkOrder>>>
export type GetWorkOrderQueryError = HTTPValidationError


export function useGetWorkOrder<TData = Awaited<ReturnType<typeof getWorkOrder>>, TError = HTTPValidationError>(
 workOrderId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof getWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkOrder<TData = Awaited<ReturnType<typeof getWorkOrder>>, TError = HTTPValidationError>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof getWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkOrder<TData = Awaited<ReturnType<typeof getWorkOrder>>, TError = HTTPValidationError>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Work Order
 */

export function useGetWorkOrder<TData = Awaited<ReturnType<typeof getWorkOrder>>, TError = HTTPValidationError>(
 workOrderId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkOrderQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateWorkOrderResponse200 = {
  data: WorkOrderOut
  status: 200
}

export type updateWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateWorkOrderResponseSuccess = (updateWorkOrderResponse200) & {
  headers: Headers;
};
export type updateWorkOrderResponseError = (updateWorkOrderResponse422) & {
  headers: Headers;
};

export type updateWorkOrderResponse = (updateWorkOrderResponseSuccess | updateWorkOrderResponseError)

export const getUpdateWorkOrderUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}`
}

/**
 * @summary Update Work Order
 */
export const updateWorkOrder = async (workOrderId: number,
    workOrderIn: WorkOrderIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateWorkOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateWorkOrderResponse>(getUpdateWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workOrderIn)
  }
);}





export const getUpdateWorkOrderMutationKey = () => ['updateWorkOrder'] as const;

export const getUpdateWorkOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkOrder>>, TError,UpdateWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkOrder>>, TError,UpdateWorkOrderMutationVariables, TContext> => {

const mutationKey = getUpdateWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkOrder>>, UpdateWorkOrderMutationVariables> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  updateWorkOrder(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkOrder>>>
    export type UpdateWorkOrderMutationBody = WorkOrderIn
    export type UpdateWorkOrderMutationError = HTTPValidationError
    export type UpdateWorkOrderMutationVariables = {workOrderId: number;data: WorkOrderIn}

    /**
 * @summary Update Work Order
 */
export const useUpdateWorkOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkOrder>>, TError,UpdateWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkOrder>>,
        TError,
        UpdateWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorkOrderMutationOptions(options), queryClient);
    }
    export type deleteWorkOrderResponse204 = {
  data: void
  status: 204
}

export type deleteWorkOrderResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteWorkOrderResponseSuccess = (deleteWorkOrderResponse204) & {
  headers: Headers;
};
export type deleteWorkOrderResponseError = (deleteWorkOrderResponse422) & {
  headers: Headers;
};

export type deleteWorkOrderResponse = (deleteWorkOrderResponseSuccess | deleteWorkOrderResponseError)

export const getDeleteWorkOrderUrl = (workOrderId: number,) => {




  return `/api/work-orders/${workOrderId}`
}

/**
 * @summary Delete Work Order
 */
export const deleteWorkOrder = async (workOrderId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteWorkOrderResponse> => {

  return apiFetch<deleteWorkOrderResponse>(getDeleteWorkOrderUrl(workOrderId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteWorkOrderMutationKey = () => ['deleteWorkOrder'] as const;

export const getDeleteWorkOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkOrder>>, TError,DeleteWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkOrder>>, TError,DeleteWorkOrderMutationVariables, TContext> => {

const mutationKey = getDeleteWorkOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkOrder>>, DeleteWorkOrderMutationVariables> = (props) => {
          const {workOrderId} = props ?? {};

          return  deleteWorkOrder(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkOrderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkOrder>>>

    export type DeleteWorkOrderMutationError = HTTPValidationError
    export type DeleteWorkOrderMutationVariables = {workOrderId: number}

    /**
 * @summary Delete Work Order
 */
export const useDeleteWorkOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkOrder>>, TError,DeleteWorkOrderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkOrder>>,
        TError,
        DeleteWorkOrderMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWorkOrderMutationOptions(options), queryClient);
    }
